import {
  SET_PRIMARY_INFO,
  SET_DISPLAY_PHOTO,
  SET_PREFERENCE_IDS,
  ADD_CARD_DETAILS,
  SET_ACCOUNT_STATUS,
  DISPLAY_PROFILE_MODAL,
  SET_PROFILE_MODAL_PAGE,
  SET_NOTIFICATION_COUNT,
  SET_EMAIL_VERIFICATION_STATUS,
  SET_FAVORITE_MALLS,
  SET_PROFILE_MODAL_DETAIL_PAGE,
  SET_TRANSPORTATION_MALL,
  CLEAR_PRIMARY_INFO,
  SET_SURVEY_MODAL_STATUS,
  // TODO: import action types added later
} from './actions/types'

import { MAIN } from '../../services/data/profilePages.json'
// import { setTransportationMall } from './actions/creators'

const INITIAL_STATE = {
  primaryInfo: null,
  preferenceIds: [],
  advanceAccount: null,
  emailVerificationStatus: null,
  verifiedMobileNumber: false,
  displayPhoto: null,
  skipSelectDisplayPhoto: false,
  cardsAdded: null,
  skipAddCard: false,
  showProfileModal: false,
  profileModalPage: MAIN,
  profileDetailPage: null,
  notificationCount: null,
  favoriteMalls: [],
  transportationMall: null,
  surveyModalStatus: false,
  surveyData: {
    question1: '',
    question2: '',
    question3: '',
  },
}

function setPrimaryInfo(state, action) {
  return {
    ...state,
    primaryInfo: {
      ...state.primaryInfo,
      ...action.payload.primaryInfo,
    },
  }
}
function clearPrimaryInfo(state) {
  return {
    ...state,
    primaryInfo: null,
  }
}
function setDisplayPhoto(state, action) {
  return {
    ...state,
    displayPhoto: action.payload.displayPhoto,
  }
}
function setPreferenceIds(state, action) {
  return {
    ...state,
    preferenceIds: action.payload.ids,
  }
}
function setCardAdded(state, action) {
  return {
    ...state,
    cardsAdded: [...state.cardsAdded, action.payload.cardsAdded],
  }
}
function setAccountStatus(state, action) {
  return {
    ...state,
    advanceAccount: action.payload.advanceAccount,
  }
}
function displayProfileModal(state, action) {
  return {
    ...state,
    showProfileModal: action.payload.showProfileModal,
    profileModalPage: MAIN,
  }
}
function setProfileModalPage(state, action) {
  return {
    ...state,
    profileModalPage: action.payload.profileModalPage,
  }
}
function setProfileModalDetailPage(state, action) {
  return {
    ...state,
    profileDetailPage: action.payload.profileDetailPage,
  }
}
function setNotificationCount(state, action) {
  return {
    ...state,
    notificationCount: action.payload.notificationCount,
  }
}
function setEmailVerificationStatus(state, action) {
  return {
    ...state,
    emailVerificationStatus: action.payload.emailVerificationStatus,
  }
}
function setFavoriteMalls(state, action) {
  return {
    ...state,
    favoriteMalls: action.payload.favoriteMalls,
  }
}
function setTransportationMall(state, action) {
  return {
    ...state,
    transportationMall: action.payload.transportationMall,
  }
}
function setSurveyModalStatus(state, action) {
  return {
    ...state,
    surveyModalStatus: action.payload.surveyModalStatus,
  }
}
// TODO: reflect state mutator functions for action types added later

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_PRIMARY_INFO:
      return setPrimaryInfo(state, action)
    case CLEAR_PRIMARY_INFO:
      return clearPrimaryInfo(state)
    case SET_DISPLAY_PHOTO:
      return setDisplayPhoto(state, action)
    case SET_PREFERENCE_IDS:
      return setPreferenceIds(state, action)
    case ADD_CARD_DETAILS:
      return setCardAdded(state, action)
    case SET_ACCOUNT_STATUS:
      return setAccountStatus(state, action)
    case DISPLAY_PROFILE_MODAL:
      return displayProfileModal(state, action)
    case SET_PROFILE_MODAL_PAGE:
      return setProfileModalPage(state, action)
    case SET_PROFILE_MODAL_DETAIL_PAGE:
      return setProfileModalDetailPage(state, action)
    case SET_NOTIFICATION_COUNT:
      return setNotificationCount(state, action)
    case SET_EMAIL_VERIFICATION_STATUS:
      return setEmailVerificationStatus(state, action)
    case SET_FAVORITE_MALLS:
      return setFavoriteMalls(state, action)
    case SET_TRANSPORTATION_MALL:
      return setTransportationMall(state, action)
    case SET_SURVEY_MODAL_STATUS:
      return setSurveyModalStatus(state, action)
    // TODO: add more action types if necessary
    default:
      break
  }

  return state
}

export default reducer
